<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.7854 6.13867C55.7854 7.9336 54.3257 9.38867 52.5252 9.38867C50.7246 9.38867 49.265 7.9336 49.265 6.13867C49.265 4.34375 50.7246 2.88867 52.5252 2.88867C54.3257 2.88867 55.7854 4.34375 55.7854 6.13867ZM54.6986 26.3609C54.6986 38.7259 44.6433 48.7498 32.2395 48.7498C19.8356 48.7498 9.78027 38.7259 9.78027 26.3609C9.78027 13.9959 19.8356 3.97201 32.2395 3.97201C44.6433 3.97201 54.6986 13.9959 54.6986 26.3609ZM59.2267 12.6387C60.127 12.6387 60.8568 11.9111 60.8568 11.0137C60.8568 10.1162 60.127 9.38867 59.2267 9.38867C58.3264 9.38867 57.5966 10.1162 57.5966 11.0137C57.5966 11.9111 58.3264 12.6387 59.2267 12.6387Z"
      fill="url(#paint0_radial_9931_22887)"
    />
    <path
      d="M23.1831 11.5558C23.1831 10.758 23.8318 10.1113 24.6321 10.1113L40.2086 10.1114C41.0089 10.1114 41.6576 10.7581 41.6576 11.5558V31.0558C41.6576 31.8535 41.0089 32.5002 40.2086 32.5002H24.6321C23.8318 32.5002 23.1831 31.8535 23.1831 31.0558V11.5558Z"
      fill="url(#paint1_radial_9931_22887)"
    />
    <path
      d="M22.0967 15.5284C22.0967 14.7307 22.7454 14.084 23.5457 14.084H41.2957C42.0959 14.084 42.7446 14.7307 42.7446 15.5284V37.5562C42.7446 38.3539 42.0959 39.0006 41.2957 39.0006H23.5457C22.7454 39.0006 22.0967 38.3539 22.0967 37.5562V15.5284Z"
      fill="url(#paint2_radial_9931_22887)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.9944 31.7784H27.1251C27.039 31.6826 26.9867 31.5561 26.9867 31.4173V27.9868H24.9944L24.9944 31.7784ZM24.2699 26.9034H23.9076C23.6075 26.9034 23.3643 27.1459 23.3643 27.4451C23.3643 27.7443 23.6075 27.9868 23.9076 27.9868H24.2699L24.2699 31.7784C24.2699 32.1773 24.5942 32.5007 24.9944 32.5007L39.8464 32.5007C40.2465 32.5007 40.5709 32.1773 40.5709 31.7784V27.9868H41.2954C41.5955 27.9868 41.8387 27.7443 41.8387 27.4451C41.8387 27.1459 41.5955 26.9034 41.2954 26.9034H40.5709V24.5562C40.5709 24.1573 40.2465 23.834 39.8464 23.834L24.9944 23.834C24.5942 23.834 24.2699 24.1573 24.2699 24.5562V26.9034ZM24.9944 26.9034V24.5562L26.9867 24.5562V26.9034H24.9944ZM28.0734 27.9868V31.4173C28.0734 31.5561 28.0211 31.6826 27.9351 31.7784L31.8342 31.7784C31.7482 31.6826 31.6959 31.5561 31.6959 31.4173V27.9868H28.0734ZM31.6959 26.9034H28.0734V24.5562L31.6959 24.5562V26.9034ZM32.7826 27.9868V31.4173C32.7826 31.5561 32.7303 31.6826 32.6443 31.7784H36.1812C36.0951 31.6826 36.0428 31.5561 36.0428 31.4173V27.9868H32.7826ZM36.0428 26.9034H32.7826V24.5562L36.0428 24.5562V26.9034ZM37.1296 27.9868V31.4173C37.1296 31.5561 37.0772 31.6826 36.9912 31.7784H39.8464V27.9868H37.1296ZM39.8464 26.9034H37.1296V24.5562L39.8464 24.5562V26.9034Z"
      fill="#DCE2EE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.6687 16.2043C37.8945 16.4013 37.9174 16.7435 37.7198 16.9687L35.0254 20.0384C34.6862 20.4248 34.0923 20.4518 33.7193 20.0976L33.2012 19.6058L31.7663 21.0482C31.4826 21.3334 31.0441 21.3975 30.6903 21.2055L29.6016 20.6149L28.2361 21.726C28.0036 21.9152 27.6614 21.8807 27.4716 21.649C27.2818 21.4172 27.3164 21.076 27.5489 20.8868L29.0086 19.699C29.2936 19.467 29.691 19.43 30.0142 19.6053L31.0904 20.1892L32.5545 18.7173C32.9017 18.3683 33.4651 18.3603 33.8221 18.6993L34.3319 19.1833L36.9019 16.2553C37.0996 16.0302 37.4428 16.0073 37.6687 16.2043Z"
      fill="url(#paint3_radial_9931_22887)"
    />
    <path
      d="M18.1118 24.9171C18.1118 24.1194 18.7605 23.4727 19.5608 23.4727L23.4721 23.4727C23.9973 23.4727 24.4813 23.756 24.7373 24.2131L27.4853 29.1211C27.7413 29.5783 28.2254 29.8616 28.7505 29.8616L36.0904 29.8616C36.6156 29.8616 37.0997 29.5783 37.3557 29.1211L40.1037 24.2132C40.3596 23.756 40.8437 23.4727 41.3689 23.4727L45.2802 23.4727C46.0804 23.4727 46.7292 24.1194 46.7292 24.9172V38.6393C46.7292 39.4371 46.0804 40.0838 45.2802 40.0838H19.5608C18.7605 40.0838 18.1118 39.4371 18.1118 38.6393V24.9171Z"
      fill="url(#paint4_radial_9931_22887)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8927 36.8331C28.2928 36.8331 28.6172 36.5098 28.6172 36.1109C28.6172 35.712 28.2928 35.3887 27.8927 35.3887L20.2855 35.3887C19.8854 35.3887 19.561 35.712 19.561 36.1109C19.561 36.5098 19.8854 36.8331 20.2855 36.8331L27.8927 36.8331ZM24.9947 38.9998C25.3948 38.9998 25.7192 38.6764 25.7192 38.2776C25.7192 37.8787 25.3948 37.5553 24.9947 37.5553L20.2855 37.5553C19.8854 37.5553 19.561 37.8787 19.561 38.2776C19.561 38.6764 19.8854 38.9998 20.2855 38.9998L24.9947 38.9998Z"
      fill="url(#paint5_radial_9931_22887)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_9931_22887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.1629 -9.20855) rotate(115.508) scale(69.8193 69.9573)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_9931_22887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.2392 24.0141) rotate(-90) scale(14.625 19.8442)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9931_22887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(35.0017 49.5974) rotate(-108.735) scale(37.5003 41.1082)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_9931_22887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.3109 19.8394) rotate(-180) scale(25.1181 13.6269)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9931_22887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.2633 71.3893) rotate(-90) scale(56.2222 55.3478)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.714491" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9931_22887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.0753 45.1612) rotate(-42.8295) scale(19.4215 37.1439)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
    </defs>
  </svg>
</template>
